import { autoinject } from "aurelia-dependency-injection";

//Load styles
require("../../../styles/contact-sales-confirmation/core-contact-sales-confirmation.scss");

@autoinject
export class LayoutContactSalesConfirmation {

}